import * as angular from "angular";
import {IController} from "angular";
import {ActionReasonModel} from "../../models/action-reason.model";
import * as _ from "lodash";
import {ActionReasonVisibilityEnum} from "../../enums/action-reason-visibility.enum";

export class ActionReasonsTableRowComponent implements IController {

  actionReason: ActionReasonModel;
  onUpdateActionReason: Function;
  onDeleteActionReason: Function;

  public agentAppEnabled: boolean;
  public consoleEnabled: boolean;

  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.actionReason && this.actionReason) {
      const actionReasonVisibilitiesList = _.get(this.actionReason, 'visibilities', []);
      this.agentAppEnabled = !!_.find(actionReasonVisibilitiesList, (crv) => {
        return crv === ActionReasonVisibilityEnum.Agent;
      });
      this.consoleEnabled = !!_.find(actionReasonVisibilitiesList, (crv) => {
        return crv === ActionReasonVisibilityEnum.Admin;
      })
    }
  };
}

angular
  .module('bringoz.admin.action-reasons')
  .component('actionReasonsTableRow', {
    bindings: {
      actionReason: '<',
      onUpdateActionReason: '&',
      onDeleteActionReason: '&'
    },
    template: require('./action-reasons-table-row.html').default,
    controller: ActionReasonsTableRowComponent
  });
